import AnswerSelection from "./AnswerSelection";
import { useStrategicSuggestions } from "../../contexts/StrategicSuggestionsContext";
// type EvalQuestionProps = {
//     id: number;
//     index: number;
//     text: string;
//     helpText: string;
//     attribute_id: number;
//     example: string;
//     videoUrl?: string;
//     questionType: oneOf(QuestionTypes);
//     sequence: number;
//     threshold: number;
//     answerChoices: [];
//     currentAnswer: number;
// };

const EvaluationQuestion = ({ question, answer, handleAnswer, onNext, waiting }) => {
    const { id, text, helpText, example, videoUrl } = question;
    const { strategicSuggestions } = useStrategicSuggestions();
    const { byAttrId: suggestionByAttrId } = strategicSuggestions;
    const attrSuggestion = suggestionByAttrId[question.attribute_id];

    const getVideoComponent = (url) => {
        // Check if it's a YouTube URL
        if (url.includes('youtube.com') || url.includes('youtu.be')) {
            const embedUrl = url.includes('youtube.com/watch?v=') 
                ? url.replace('watch?v=', 'embed/')
                : url.replace('youtu.be/', 'youtube.com/embed/');
                
            return (
                <iframe
                    width="640"
                    height="480"
                    src={embedUrl}
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                    style={{ maxWidth: "100%" }}
                />
            );
        }
        
        // Check if it's a Vimeo URL
        if (url.includes('vimeo.com')) {
            const videoId = url.split('/').pop();
            return (
                <iframe
                    width="640"
                    height="480"
                    src={`https://player.vimeo.com/video/${videoId}`}
                    title="Vimeo video player"
                    frameBorder="0"
                    allow="autoplay; fullscreen; picture-in-picture"
                    allowFullScreen
                    style={{ maxWidth: "100%" }}
                />
            );
        }
        
        // For direct video files (.mp4, .webm, .ogg, etc.)
        return (
            <video style={{ width: "100%", maxWidth: 640, minHeight: 480, height: "auto" }} controls>
                <source src={url} type="video/mp4" />
                Your browser does not support the video tag.
            </video>
        );
    };

    return (
        <div key={id} className={`evaluation-question`}>
          <div className="question-header">
            {/* <h3 className="wellness-question-id">Question {sequence} {QuestionTypes[questionType]}</h3> */}
            <p className="wellness-question-title-text">{text}</p>
          </div>
          <AnswerSelection 
                question={question} 
                answer={answer}
                handleAnswer={handleAnswer}
          />
          <div className="question-extra-info">
            {helpText && (
              <div className="question-help-text" style={{ marginTop: "1.5rem", marginBottom: "0.5rem" }}>
                <em style={{ fontWeight: "bold", fontStyle: "italic", marginRight: "0.5rem" }}>Hint:</em>
                <span style={{ fontStyle: "italic" }}>{helpText}</span>
              </div>
            )}
            {/* Submit button and validation message */}
            {onNext && (
              <div className="button-row">
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    marginTop: "2rem",
                    width: "100%",
                  }}
                >
                  <div style={{ width: "120px" }}></div>
                  {/* Message in the center */}
                  <div style={{ minHeight: "1.5em" }}>
                    {waiting ? (
                      <span style={{ color: "#555" }}>Saving your answer...</span>
                    ) : !answer ? (
                      <span style={{ color: "red" }}>Please select an answer</span>
                    ) : null}
                  </div>
                  {/* Submit button on the right */}
                  <button 
                    className="submit-btn" 
                    onClick={onNext}
                    disabled={waiting || !answer}
                  >
                    {waiting ? (
                      <>
                        <span className="spinner"></span>
                        Saving...
                      </>
                    ) : (
                      'Submit'
                    )}
                  </button>
                </div>
              </div>
            )}
            {example && <p className="question-example-text"><strong>Example:</strong> {example}</p>}
            {videoUrl && (
              <div className="question-video" style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
                {getVideoComponent(videoUrl)}
              </div>
            )}
            {attrSuggestion && attrSuggestion.linksMap['For Athletes'] && (
              <div className="question-suggestion" style={{ marginTop: "1.5rem", marginBottom: "0.5rem" }}>
                <em style={{ fontWeight: "bold", fontStyle: "italic", marginRight: "0.5rem" }}>Reference for athletes:</em>
                <ul style={{ marginLeft: "2em" }}>
                  {attrSuggestion.linksMap['For Athletes'].map((link, idx) => (
                    <li key={link.url || idx}>
                      <a href={link.url} target="_blank" rel="noopener noreferrer">
                        {link.title}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
        </div>
    );
}

export default EvaluationQuestion;
